/* eslint-disable max-lines */
export const IDP_APP = 'LOGIN_MODAL';
export const AEM_EMAIL = 'xxx@delta.com';
export enum LOGIN_PAGE_ROUTES {
  ADD_SQA_ROUTE = '/user-login/addSQA?redirect=true',
  ADD_EMAIL_ROUTE = '/user-login/addEmail?redirect=true',
  ADD_ADDRESS_ROUTE = '/user-login/addAddress?redirect=true',
  LOGIN_PICKER = '/content/www/en_US/global-login/loginmodalpage.html/skymiles/profilePickerPage/',
  LOGIN_PICKER_STANDALONE = 'skymiles/profilePickerPage',
  CREATE_NEW_PWD = '/user-login/createPassword',
  RECOVER_ACCOUNT = '/user-login/loginPage?recoverAccount=true'
}

export const RESTRICT_AUTH_CALLS_URL = ['/skymiles/login'];

export const LOGIN_PICKER_RESTRCITED_PAGE_LIST = [
  '/flight-search-2/search',
  '/flight-search-2/search-results',
  '/flight-search-2/flexible-airports',
  '/flight-search-2/flexible-dates',
  '/completepurchase/trip-summary',
  '/completepurchase/express-checkout',
  '/completepurchase/review-pay',
  '/complete-purchase/trip-summary',
  '/complete-purchase/express-checkout',
  '/complete-purchase/review-pay',
  '/flight-search/search-results',
  '/flight-search/',
  '/seat-map/ISM/',
  '/seat-map-nxtgen/',
  '/seats/',
  '/edocs/redeem-documents',
  '/redeem-ecredit/',
  '/cart/activity/tripsummary.action',
  '/cart/activity/passengerinfo.action',
  '/cart/activity/reviewFlight.action',
  '/flightsearch/',
  '/flight-search/reshop-modify',
  '/flight-search/reshop-results',
  '/nextgencheckout/change-trip.html/',
  '/change-trip/'
];

export const LOGIN_PICKER_IN_RESHOP_CONFIRMATION = [
  '/nextgencheckout/change-trip.html/confirmation',
  '/change-trip/confirmation'
];

export const LOGIN_CONSTANTS = {
  EMAIL: 'email',
  USER_NAME: 'userName',
  SKYMILES_NUMBER: 'skymilesNumber',
  RECOVERY_OPTION_EMAIL: 'email',
  RECOVERY_OPTION_SQA: 'sqa',
  APP_PREFIX_TL: 'tlMaskInfo_',
  APP_SUFFIX_TL: ''
};

export const ERROR_CODES = {
  ERROR_CODE_111: '111',
  ERROR_CODE_222: '222',
  ERROR_CODE_21: '21'
};

export const ENCRYPTED_FIELDS = {
  LOGIN_USERNAME: 'login_username',
  LOGIN_PASSWORD: 'login_password',
  LOGIN_LAST_NAME: 'login_lastName',
  LOGIN_TOKEN_ID: 'login_tokenId'
};

export const PARAMS_TO_IGNORE = [
  'login_tokenId',
  'login_username',
  'login_lastName',
  'login_password',
  'login_refreshURL',
  'refreshURL',
  'login_isPersistent',
  'login_reasonCode',
  'login_maskedEmail'
];

export const VIEW_NAME = {
  LOGIN_CREDENTIALS_SCREEN: 'loginCredentials',
  FORGOT_LOGIN_SCREEN: 'forgotLogin',
  RESET_PASSWORD_SCREEN: 'resetPassword',
  ADD_ADDRESS_SCREEN: 'addAddress',
  ADD_EMAIL_ADDRESS_SCREEN: 'addEmailAddress',
  ADD_SECURITY_QUESTION_ANS_SCREEN: 'addSecurityQuestionAnswers',
  CHECK_YOUR_EMAIL_SCREEN: 'checkYourEmail',
  CHOOSE_RECOVERY_OPTIONS_SCREEN: 'chooseRecoveryOptions',
  CREATE_PASSWORD_SCREEN: 'createPassword',
  LOGIN_HELP_SCREEN: 'loginHelp',
  UNLOCK_ACCOUNT_SCREEN: 'unlockAccount',
  RESOURCE_NOT_FOUND_SCREEN: 'resourceNotFound',
  SECURITY_QUESTION_ANSWER_SCREEN: 'securityQuestionAnswers',
  SET_PASSWORD_SCREEN: 'setPassword',
  RECOVER_ACCOUNT_SCREEN: 'recoverAccount',
  PROFILE_PICKER: 'skymiles/profilePickerPage',
  PROFILE_PICKER_PAGE: 'profilePickerPage',
  NEW_RESET_PASSWORD_CHECK_YOUR_EMAIL_SCREEN: 'newResetPasswordCheckYourEmail'
};

export const COOKIE_DOMAIN = ';domain=.delta.com; path=/';
export const DEFAULT_MODAL_ERROR_CODE = 'ERROR_MSG_MODAL_21';
export const DEFAULT_ERROR_CODE_LOGIN_BFF = '23';
export const ERROR_CODE_413 = '413';
export const RECOVER_ACCOUNT_SCREEN_ERROR_CODES = ['111', '39', '139', '138'];
export const MY_TRIPS_REDIRECTION = '/mytrips/findPnr.action';
export const CANCEL_TRIP_CONFIRMATION_REDIRECTION = '/cancel-trip/confirmation';
export const RECOGNITION_PATHNAME_REGEX = /\b(recognition)\b/;
export const BUSINESS_PROFILE_REDIRECTION = 'cancel-trip.html';

export const STANDALONE_PAGE_URL = {
  [VIEW_NAME.LOGIN_CREDENTIALS_SCREEN]: 'login',
  [VIEW_NAME.FORGOT_LOGIN_SCREEN]: 'forgotLogin',
  [VIEW_NAME.RESET_PASSWORD_SCREEN]: 'resetPassword',
  [VIEW_NAME.UNLOCK_ACCOUNT_SCREEN]: 'unlockYourAccount',
  [VIEW_NAME.LOGIN_HELP_SCREEN]: 'loginHelp',
  [VIEW_NAME.PROFILE_PICKER]: 'profilePickerPage',
  [VIEW_NAME.ADD_EMAIL_ADDRESS_SCREEN]: 'addEmail',
  [VIEW_NAME.ADD_SECURITY_QUESTION_ANS_SCREEN]: 'addSQA',
  [VIEW_NAME.ADD_ADDRESS_SCREEN]: 'addAddress'
};

export const LOGIN_MODAL_STANDALONE_URL = [
  'login',
  'forgotLogin',
  'resetPassword',
  'unlockYourAccount',
  'loginHelp',
  'profilePickerPage',
  'addEmail',
  'addSQA',
  'addAddress'
];

export const IROP_ERROR = 'iropError';

export const REFRESH_URL = 'refreshURL';
export const REDIRECT_BACK = 'redirectBack';
export const FROM_APP = 'login_fromApp';
export const FLOW_ID = 'flowId';
export const BAU_REFRESH_URL = 'bauRefreshURL';
export const SHOPPING_APP_NAME = 'shopping-slice';
export const RESHOP_APP_NAME = 'reshop-slice';
export const WIFI_IDENTIFICATION_PATH = '/identification?hardLock=true';
export const COUNTRY_CODE = 'countryCode';
export const HOME_PAGE_URL = '/';
export const ADD_ADDRESS_DEFAULT_COUNTRY_CODE = 'US';
export const MFA_FLOW_FIRST_SCREEN = '/skymiles/emailVerification';
export const MFA_FLOW_ACCOUNT_RECOVERY_FIRST_SCREEN =
  '/skymiles/selectVerificationMethod';

export const MFA_SETUPLATER_TIMESTAMP = 1000 * 60 * 60 * 24;

export const WIFI_PORTAL_NO_SQA_MESSAGE =
  "<p>Keeping your information safe matters to us. We're sorry for any inconvenience, but in order to reset your password in flight you must have security questions in place.</p><p>You can still connect to Wi-Fi by entering some basic credentials to confirm you are an existing SkyMiles Member</p>";

export const WIFI_PORTAL_SQA_SUBTITLE_TEXT =
  "We've sent a reset password link to your email, but you can continue with your security questions and answers to reset your password.";

export const SKYMILES_NUMBER_LABEL = 'Skymiles Number*';
export const RESET_PASSWORD_INLINE_ERROR_MESSAGE =
  'is incorrect. Please try again.'; /** Use this as common inline error message by prefixing field name dynamically  */
